import React from "react";
import classes from "./quantityCounter.module.scss";

const QuantityCounter = ({ qty, onDecrement, onIncrement }) => {
  return (
    <div className={classes.quantity_counter}>
      <input
        type="button"
        value="-"
        className={classes.button}
        onClick={onDecrement}
        aria-label="Decrease quantity"
      />
      <input
        type="number"
        step="1"
        min="1"
        max=""
        name="quantity"
        value={qty}
        title="Qty"
        className={classes.input}
        size="4"
        pattern=""
        inputMode=""
        readOnly
      />
      <input
        type="button"
        value="+"
        className={classes.button}
        onClick={onIncrement}
        aria-label="Increase quantity"
      />
    </div>
  );
};

export default QuantityCounter;
